import styled from 'styled-components';

import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $PlanPreview = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${spacing(10)};
  & h4 {
    white-space: nowrap;
  }
`;

export const $PreviewFeatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('lg')};
`;

export const $PreviewFeatureHeading = styled.div`
  font-weight: ${fontWeight('bold')};
  margin-bottom: ${spacing('lg')};

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  &::first-letter {
    text-transform: capitalize;
  }
`;

export const $PlanPreviewTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${spacing(10)};
`;

export const $TagIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    margin-right: ${spacing('sm')};
  }
`;
